export default defineNuxtPlugin(() => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    document.cookie = `client_timezone=${encodeURIComponent(timeZone)}; path=/;`
})
